import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Users } from "../../api/account/Users";
import { Publications as _Pub } from "../../api/compute/Publications";
import { Utils } from "../../api/compute/Utils";
import { SHARED_OBJECT_TYPE_UI_TO_SERVER } from "../../api/compute/_CommonPublicationsSubscriptions";
import { useAuth } from "../../hooks/useAuth";
import { httpAll } from "../../httpAll";
import PublicationCard from "./PublicationCard";
import { publicationsGet } from "./utils";
import { useFeedbackSystem } from "../../hooks/useFeedbackSystem";

const keysMap = {
  baskets: "Baskets",
  portfolios: "Portfolios",
  rankings: "Rankings",
  strategies: "Strategies",
  systematicPortfolios: "Systematic Portfolios",
  combinedStrategies: "Combined Strategies",
  combinedProducts: "Combined Systematic Portfolios",
  screening: "Screening",
};

const getType = (obj) => {
  switch (obj.type) {
    case "strategies":
      return "Strategy";
    case "systematicPortfolios":
      return "Systematic portfolio";
    case "rankings":
      return "ranking";
    case "combinedStrategies":
      return "Combined Strategies";
    case "combinedProducts":
      return "Combined Systematic portfolios";
    default:
      return null;
  }
};

export default function Publications() {
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState<any>(null);
  const feedback = useFeedbackSystem();

  const fetchData = useCallback(() => {
    setIsLoading(true);
    let userData = auth.user35;
    if (userData) {
      publicationsGet(userData).then(
        (response) => {
          setIsLoading(false);
          setState(response);
          console.log("publication state", response);
        },
        (error) => {
          // feedback.show({ type: "error", message: error.message });
          console.log("something went wrong at publications fetching!");
          setIsLoading(false);
        }
      );
    }
  }, [auth.user35]);
  useEffect(() => {
    if (auth.isLogged) {
      fetchData();
    }
  }, [auth.isLogged, fetchData]);

  const subscribePublication = useCallback(
    (obj) => {
      const publication = state[obj.type]?.filter(
        (item) => item.id === obj.id
      )[0];
      var params = {
        id: publication.id,
        type: publication.pubSubType,
        user: auth.user35,
      };
      const pub = new _Pub();
      return pub.create(params).then((response) => {
        if (response.status === "OK") {
          feedback.show({
            type: "success",
            message: `Successfully shared "${publication.name}"`,
          });
          fetchData();
        } else {
          feedback.show({
            type: "error",
            message: `Error on sharing "${publication.name}"`,
          });
        }
      });
    },
    [auth.user35, feedback, fetchData, state]
  );
  const unsubscribePublication = useCallback(
    (obj) => {
      const publication = state[obj.type]?.filter(
        (item) => item.publicationId === obj.publicationId
      )[0];
      var paramsRelations: any = {
        action: "unpublish",
        item: publication,
        user: { id: 35 },
      };

      const utils = new Utils();
      const user = new Users();
      const pub = new _Pub();

      setIsLoading(true);
      return utils
        .relations(paramsRelations)
        .then(async (response) => {
          var requests: any = [];
          //! ------------------------------
          // if relations.length>0 obj can't be unpublished:
          //#region
          let testObj = {};
          const relations: any[] = response.data.relations;
          relations.forEach((relation: any[]) => {
            const sharedObjTypes: any[] = Object.values(
              SHARED_OBJECT_TYPE_UI_TO_SERVER
            );
            sharedObjTypes.forEach((objType) => {
              if (relation[relation.length - 1].type === objType) {
                if (testObj[objType] != null) {
                  testObj[objType].push(relation[relation.length - 1].id);
                } else {
                  testObj[objType] = [relation[relation.length - 1].id];
                }
              }
            });
          });
          let feedbackStr = "";
          Object.keys(testObj).forEach((objType) => {
            feedbackStr = `It has been used in:\n`;
            let str = "";
            if (
              objType === SHARED_OBJECT_TYPE_UI_TO_SERVER.systematicPortfolio
            ) {
              str +=
                "- Systematic portfolios: " +
                testObj[objType].join(", ") +
                "\n";
            }
            feedbackStr = feedbackStr + str;
          });

          for (const relationChain of response.data.relations) {
            //! comment by stefano
            // the last element of the chain is the real dependency
            // chain with multiple relation are related to shared items
            //! ----
            const relation = relationChain[relationChain.length - 1];
            if (relation.type === "SUBSCRIPTION") {
              requests.push(
                user
                  .get({
                    ids: [relation["userId"]],
                    properties: ["firstName", "lastName", "email"],
                  })
                  .then((responseGet) => {
                    var user = responseGet.data[0].rows[0];
                    if (user) {
                      return {
                        name: [
                          user.firstName,
                          user.lastName,
                          "-",
                          user.email,
                          "- ID:",
                          user.id,
                        ].join(" "),
                        type: relation["type"],
                      };
                    } else {
                      return {
                        name: [
                          "unknown",
                          "unknown",
                          "-",
                          "unknown",
                          "- ID:",
                          "unknown",
                        ].join(" "),
                        type: relation["type"],
                      };
                    }
                  })
              );
            }
          }
          if (requests.length > 0) {
            const resp = await httpAll(requests);
            if (resp != null && resp.length > 0) {
              feedbackStr += `It has been subscribed by:\n`;
              resp.forEach((item) => (feedbackStr += `-${item.name}\n`));
            }
          }
          if (feedbackStr.length > 0) {
            throw new Error(
              `${getType(obj)} can't be unpublished!\n${feedbackStr}`
            );
          }
          //#endregion

          //! solo se non ci sono dipendenze!
          var paramsRemove = {
            id: publication.id,
            type: publication.pubSubType,
          };
          return pub.remove(paramsRemove);
        })
        .then(
          (res) => {
            setIsLoading(false);
            if (res.status === "OK") {
              feedback.show({
                type: "success",
                message: `Successfully unshared "${publication.name}"`,
              });
              fetchData();
            } else {
              feedback.show({
                type: "error",
                message: `Error on unsharing "${publication.name}"`,
              });
            }
          },
          (error) => {
            setIsLoading(false);
            feedback.show({
              type: "warning",
              message: <pre>{error.message}</pre>,
              isBig: true,
            });
          }
        );
    },
    [feedback, fetchData, state]
  );

  const [selectedTab, setSelectedTab] = useState(
    state ? Object.keys(state)[0] : "strategies"
  );

  return isLoading ? (
    <Box
      display={"flex"}
      gap={2}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      width={"100%"}
      height={"100%"}
    >
      <Typography>Loading data...</Typography>
      <CircularProgress color="secondary" />
    </Box>
  ) : (
    <Box
      height={"100%"}
      width={"100%"}
      gap={2}
      borderRadius={1}
      display={"flex"}
      overflow={"auto"}
    >
      <Box display={"flex"} p={0.5} gap={2} width={"100%"} overflow={"hidden"}>
        <Box
          display={"flex"}
          gap={1}
          boxShadow={3}
          justifyContent={"flex-start"}
          alignContent={"flex-start"}
          p={1}
          overflow={"auto"}
          // width={"100%"}
          borderRadius={2}
          // flexWrap={"wrap"}
          flexDirection={"column"}
        >
          {state != null &&
            Object.keys(state).map((key, index) => {
              if (key !== "storeData") {
                return (
                  <Button
                    sx={
                      {
                        // flexWrap: "wrap",
                        // display: "flex",
                        // width: "100%",
                        // maxWidth: "200px",
                      }
                    }
                    title={keysMap[key]}
                    color={selectedTab === key ? "secondary" : "primary"}
                    onClick={() => setSelectedTab(key)}
                  >
                    <Typography
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {keysMap[key]}
                    </Typography>
                  </Button>
                );
              }
              return null;
            })}
        </Box>

        {state != null && (
          <PublicationCard
            subscribePublication={subscribePublication}
            unsubscribePublication={unsubscribePublication}
            type={selectedTab}
            title={keysMap[selectedTab]}
            data={state[selectedTab]}
          />
        )}

        {/* {state != null &&
          Object.keys(state).map((key, index) => {
            if (key !== "storeData") {
              return (
                <PublicationCard
                  subscribePublication={subscribePublication}
                  unsubscribePublication={unsubscribePublication}
                  key={index}
                  type={key}
                  title={keysMap[key]}
                  data={state[key]}
                />
              );
            }
            return null;
          })} */}
      </Box>
    </Box>
  );
}
